export var FilterOperators;
(function (FilterOperators) {
    FilterOperators["eq"] = "eq";
    FilterOperators["noteq"] = "noteq";
    FilterOperators["lt"] = "lt";
    FilterOperators["gt"] = "gt";
    FilterOperators["lte"] = "lte";
    FilterOperators["gte"] = "gte";
    FilterOperators["contains"] = "contains";
    FilterOperators["startswith"] = "startswith";
    FilterOperators["endswith"] = "endswith";
    FilterOperators["notcontains"] = "notcontains";
})(FilterOperators || (FilterOperators = {}));
export const filterOperatorsMap = {
    [FilterOperators.eq]: '=',
    [FilterOperators.noteq]: '!=',
    [FilterOperators.lt]: '<',
    [FilterOperators.gt]: '>',
    [FilterOperators.lte]: '<=',
    [FilterOperators.gte]: '>=',
    [FilterOperators.contains]: '%%',
    [FilterOperators.startswith]: '=%',
    [FilterOperators.endswith]: '%=',
    [FilterOperators.notcontains]: '!%',
};
export var DBDatasourceMethods;
(function (DBDatasourceMethods) {
    DBDatasourceMethods["get"] = "get";
    DBDatasourceMethods["list"] = "list";
    DBDatasourceMethods["create"] = "create";
    DBDatasourceMethods["update"] = "update";
    DBDatasourceMethods["delete"] = "delete";
    DBDatasourceMethods["count"] = "count";
})(DBDatasourceMethods || (DBDatasourceMethods = {}));
export var LogicOperator;
(function (LogicOperator) {
    LogicOperator["AND"] = "AND";
    LogicOperator["OR"] = "OR";
})(LogicOperator || (LogicOperator = {}));
